// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
/* eslint-disable camelcase */

import { createAsyncAction } from 'typesafe-actions';

export interface OnlineCourseFeedbackRequestPayload {
  id: string;
  username: string;
  course: number;
  helpful: number;
  comments: string;
  success?: Function;
}

export interface OnlineCourseFeedbackFailPayload {
  error: Error;
}

export const postOnlineCourseFeedbackActions = createAsyncAction(
  'elearning/POST_ONLINE_COURSE_FEEDBACK_DATA',
  'elearning/POST_ONLINE_COURSE_FEEDBACK_DATA_SUCCESS',
  'elearning/POST_ONLINE_COURSE_FEEDBACK_DATA_FAIL'
)<OnlineCourseFeedbackRequestPayload, void, OnlineCourseFeedbackFailPayload>();
